// extracted by mini-css-extract-plugin
export default {"footer":"PriceTagModal_footer__ooIRF"};